<template>
  <card class="card-stats" :show-footer-line="true">
    <div class="row">
      <div class="col-5" v-if="$slots.icon || icon">
        <div class="info-icon text-center" :class="`icon-${type} `">
          <slot name="icon"><i :class="icon"></i></slot>
        </div>
      </div>
      <div class="col-7" v-if="$slots.content || title || subTitle">
        <div class="numbers">
          <slot>
            <h4 v-if="subTitle"  class="card-title">{{ subTitle }}</h4>
            <template>

              <h3 v-if="title" class="card-title">{{ title }}</h3>
              <h2 v-else class="card-title">
                <slot name="title" ></slot>
              </h2>
            </template>

          </slot>
        </div>
      </div>
    </div>
    <div class="stats" slot="footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </card>
</template>
<script>
import Card from './Card.vue';

export default {
  name: 'stats-card',
  components: {
    Card
  },
  props: {
    type: {
      type: String,
      default: 'primary'
    },
    icon: String,
    title: String,
    subTitle: String
  }
};
</script>
<style>
</style>
